/**
 * Creates a mutex that can be used to lock and unlock a resource.
 * @returns A mutex object. Call `lock()` to lock the resource and `release()` to
 * unlock it. `isLocked()` can be used to check if the resource is locked. Can also
 * wait for the resource to be unlocked by calling `await lock()`.
 */
export function getMutex() {
  const queue: (() => void)[] = [];
  let busy = 0;

  const isLocked = () => {
    return busy > 0;
  };

  const lock = () => {
    const promise = new Promise<void>((resolve) => {
      if (!isLocked()) {
        resolve();
        return;
      }
      queue.push(resolve);
    });

    busy++;

    return promise;
  };

  const release = () => {
    busy = Math.max(0, busy - 1);
    const resolve = queue.shift();
    if (resolve) {
      resolve();
    }
  };

  return { lock, release, isLocked };
}
